import { __awaiter, __generator } from "tslib";
import { fetchPost } from '../../../common/http';
import { getSFCCRequestHeaders } from '../../../sfcc/utilities/get-sfcc-request-headers';
import { getProductCatalogueApiConfig } from '../config/actions';
import { SearchUrlSuffix } from '../models/search-url-suffix';
import { getFetchSearchUrl } from '../utilities/get-fetch-search-url';
import { getFetchSFCCSearchBody } from '../utilities/get-fetch-sfcc-search-body';
import { getFetchSFCCSearchUrl } from '../utilities/get-fetch-sfcc-search-url';
import { setApiKeyHeader } from '../utilities/set-api-key-header';
import { validateSearchParameters } from '../utilities/validate-search-parameters';
/**
 * @internal
 */
export var fetchSearch = function (searchUrlSuffix, parameters, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    var url, options, isSFCCSearchNeeded, sfccRequestBody;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                validateSearchParameters(parameters);
                isSFCCSearchNeeded = searchUrlSuffix === SearchUrlSuffix.Groups
                    && parameters.includePrices
                    && getProductCatalogueApiConfig().isSFCCSearchOn;
                if (!isSFCCSearchNeeded) return [3 /*break*/, 3];
                url = getFetchSFCCSearchUrl();
                return [4 /*yield*/, getSFCCRequestHeaders()];
            case 1:
                options = _a.sent();
                sfccRequestBody = getFetchSFCCSearchBody(parameters, includeType);
                return [4 /*yield*/, fetchPost(url, sfccRequestBody, options)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                url = getFetchSearchUrl(searchUrlSuffix, includeType);
                options = {};
                setApiKeyHeader(options);
                return [4 /*yield*/, fetchPost(url, parameters, options)];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
}); };
